import React, { useMemo } from 'react';
import classes from './unsubscribePage.module.css';
import { useUnsubscribePage } from './useUnsubscribePage';
import { Button, Checkbox, Form, Image, Input, Spin } from 'antd';
import { Helmet } from 'react-helmet';
import eCom365Logo from "../../static/e-com365_logo.png"
import OtherForm from '../CustomFormPage/otherFormView/otherForm';
import MainComponent from '../../components/MainComponent/mainComponent';
import FormRecaptcha from '../../components/FormRecaptcha';

const UnsubscriberPage = props=>{

    const {
        loading,
        formData,
        result,
        setResult,
        selectTopics,
        setSelectTopics,
        topics,
        form,
        handleGetRules,
        handleConfirmUnSubscribe,
        handleReloadTopics,
        formClientWidth,
        setFormClientWidth,
        merchant_code,
        htmlData,
        recaptcha
    } = useUnsubscribePage();

    const defaultNode = useMemo(()=>{
        return <div className={classes.root}>
            <Spin spinning={loading}>
                <div className={classes.container}>
                    <div className={classes.header}>
                        <Image src={eCom365Logo} />
                    </div>
                    <div className={classes.title}>
                        {
                            result === true ? "Unsubscribe successfully!" : "EMAIL PREFERENCE"
                        }
                    </div>
                    <div className={classes.section}>
                        {
                            result === true ? <div className={classes.label}>
                                <p style={{color: '#00AA55'}}>You have been successfully unsubscribed from email communications.</p>
                                <br />
                            </div> : <div className={classes.label}>
                                <p>If you’d no longer like to receive promotional emails* from {merchant_code}, </p>
                                {/* <p>please review your email and click below to unsubscribe.</p> */}
                                <p>please click below to unsubscribe.</p>
                                <br />
                            </div>
                        }
                        {
                            result === true ? <div>
                                <Button className={classes.form_btn} onClick={handleReloadTopics}>
                                    Return
                                </Button>
                            </div> : <Form layout="vertical" className={classes.form} form={form} onFinish={handleConfirmUnSubscribe}>
                                {/* <Form.Item
                                    name="email"
                                    rules={handleGetRules(true, 'email', 'Email', )}
                                >
                                    <Input 
                                        placeholder='Enter the email'
                                        onChange={(val)=>{setResult(null)}}
                                    />
                                </Form.Item> */}
                                <Form.Item
                                    label={topics?.length ? "Unsubscribe Topics: " : ""}
                                    name="topics"
                                    rules={handleGetRules(true, '', 'Topics')}
                                >
                                    <Checkbox.Group
                                        options={topics}
                                        value={selectTopics}
                                        onChange={(val) => {
                                            setSelectTopics(val);
                                            setResult(null);
                                        }}
                                        style={{
                                            display: 'grid',
                                            gap: '8px',
                                            maxWidth: '100%',
                                            overflow: 'hidden',
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-all',
                                        }}
                                    />
                                </Form.Item>
                                
                                <FormRecaptcha
                                    v2Ref={recaptcha?.v2Ref}
                                    v2Config={recaptcha?.v2Config}
                                    v3Config={recaptcha?.v3Config}
                                    showV2Widget={recaptcha?.showV2Widget}
                                    showV3Widget={recaptcha?.showV3Widget}
                                    onV3Ready={recaptcha?.onV3Ready}
                                    onV3Error={recaptcha?.onV3Error}
                                    onV2Ready={recaptcha?.onV2Ready}
                                    onV2Change={recaptcha?.onV2Change}
                                    onV2Expired={recaptcha?.onV2Expired}
                                    onV2Errored={recaptcha?.onV2Errored}
                                    scriptReady={recaptcha?.scriptReady}
                                    scriptError={recaptcha?.scriptError}
                                    v2Error={recaptcha?.v2Error}
                                    v2Expired={recaptcha?.v2Expired}
                                    v2TokenReady={recaptcha?.v2TokenReady}
                                    style={{ marginBottom: '12px' }}
                                />

                                <Button className={classes.form_btn} htmlType="submit" disabled={!selectTopics?.length}>
                                    Unsubscribe
                                </Button>
                                {
                                    result !== null ? <p className={`${classes.result_tips} ${result === true ? classes.result_tips_ok : ''}`}>
                                        {result === true ? 'Unsubscribe Successful!' : result}
                                    </p> : null
                                }
                                
                            </Form>
                        }
                    </div>
                </div>
            </Spin>
        </div>
    }, [form, handleConfirmUnSubscribe, handleGetRules, handleReloadTopics, loading, result, selectTopics, setResult, setSelectTopics, topics, merchant_code, recaptcha]);

    const FormContent = useMemo(()=>{
        return formData === undefined ? defaultNode : formData ? <OtherForm 
            isEmbed={false}
            formData={formData}
            custom_form={form}
            handleSubmit={handleConfirmUnSubscribe}
            formClientWidth={formClientWidth}
            setFormClientWidth={setFormClientWidth}
            unSubData={{
                topics: topics,
                selectTopics: selectTopics,
                loading: loading,
                handleOnChange: (val)=>{
                    setSelectTopics(val);
                    setResult(null);
                },
                handleReturn: handleReloadTopics,
                result: result
            }}
            recaptcha={recaptcha}
        /> : <Spin spinning={true}></Spin>
    }, [defaultNode, form, formClientWidth, formData, handleConfirmUnSubscribe, handleReloadTopics, 
        loading, result, selectTopics, setFormClientWidth, setResult, setSelectTopics, topics, recaptcha]);

    function isIframe() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true; // 跨域访问报错时，也说明在 iframe 中
        }
    }

    return <>
        <Helmet >
            <title>{htmlData.title || 'Unsubscribe'}</title>
            <meta name="description" content={htmlData.title || 'Unsubscribe'} />
            <link rel="icon" href={htmlData.favicon || 'https://www.gaxas.ai/api/media/file/favicon-1.svg'}/>
        </Helmet>
        
        <MainComponent children={FormContent} isIframe={isIframe()} bgColor={formData?.root?.data?.backdropColor}/>
    </>
}

export default UnsubscriberPage;